module.exports = __webpack_public_path__ + "img/thestrals.a6b6a106.jpg";